import { useQuery } from '@apollo/client' // or 'react-apollo'
import getPermissions from 'graphQL/app/getPermissions'
import checkUserAccess from 'graphQL/mfaSettings/checkUser2faStatus'

const useUserPermissions = (options) => {
  return useQuery(getPermissions, options)
}

const useCheckUserAccess = (options) => {
  return useQuery(checkUserAccess, options)
}

export {
  useUserPermissions,
  useCheckUserAccess
}
